"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Preservation = void 0;
var DeleteKnowledge_1 = require("./DeleteKnowledge");
var UpdateKnowledge_1 = require("./UpdateKnowledge");
var CreateKnowledge_1 = require("./CreateKnowledge");
var ConnectKnowledge_1 = require("./ConnectKnowledge");
/**
 * This type contains all preservation sensor impulses which are used to support
 * read/write/delete memory functions in gaia.
 */
var Preservation = /** @class */ (function (_super) {
    __extends(Preservation, _super);
    function Preservation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "Preservation";
        _this.create = function (config) { return _this.push(function (registry) {
            var entity = new CreateKnowledge_1.CreateKnowledge();
            config(entity);
            return "create { " + entity.render(registry) + " }";
        }); };
        _this.update = function (config) { return _this.push(function (registry) {
            var entity = new UpdateKnowledge_1.UpdateKnowledge();
            config(entity);
            return "update { " + entity.render(registry) + " }";
        }); };
        _this.delete = function (config) { return _this.push(function (registry) {
            var entity = new DeleteKnowledge_1.DeleteKnowledge();
            config(entity);
            return "delete { " + entity.render(registry) + " }";
        }); };
        _this.connect = function (config) { return _this.push(function (registry) {
            var entity = new ConnectKnowledge_1.ConnectKnowledge();
            config(entity);
            return "connect { " + entity.render(registry) + " }";
        }); };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return Preservation;
}(Array));
exports.Preservation = Preservation;
//# sourceMappingURL=Preservation.js.map